import React, { useCallback, useState } from 'react';
import cn from 'classnames';
import isFunction from 'lodash/isFunction';
import BaseModal from './Modal';
import ModalContent from './ModalContent';
import styles from './responsiveModal.module.scss';

interface IProps {
  className?: string,
  isLoading?: boolean,
  hideOnOverlayClicked?: boolean,
  closeOnEsc?: boolean,
  children: React.ReactNode | ((footerRefCallback: any) => React.ReactElement),
  footer?: React.ReactNode,
  dataTest: string,
  title?: React.ReactNode | string,
  modalBodyClassName?: string,
  isVisible?: boolean,
  onCloseClicked?: () => void,
  showCloseButton?: boolean,
  onOverlayClicked?: () => void,
  modalTitleClassName?: string,
}

const ResponsiveModal = ({
  className = '',
  isLoading = false,
  hideOnOverlayClicked = false,
  closeOnEsc = true,
  children = null,
  footer = null,
  ...otherProps
}: IProps) => {
  // Need to use callback refs to get footer reference in modal content
  // https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
  const [footerRef, setFooterRef] = useState(null);
  const handleContextMenu = useCallback((e) => e.stopPropagation(), []);

  return (
    <BaseModal
      { ...otherProps }
      { ...(footer ? { footerRefCallback: setFooterRef } : {}) }
      footer={ footer }
      onContextMenu={ handleContextMenu }
      className={ cn(styles.modalWrp, className, {
        [styles.isLoading]: isLoading,
      }) }
      hideOnOverlayClicked={ hideOnOverlayClicked && !isLoading }
      closeOnEsc={ closeOnEsc && !isLoading }
    >
      <ModalContent
        isLoading={ isLoading }
        footerRef={ footerRef }
      >
        { /* @ts-ignore */ }
        { isFunction(children) ? children(setFooterRef) : children }
      </ModalContent>
    </BaseModal>
  );
};

export default ResponsiveModal;
